import { SETTINGS } from './../settings';

export default class ScrollAnimation {
  animationNode;
  scrollPosition;
  constructor(animationNode) {
    this.animationNode = animationNode;
  }
  setScrollPosition(scrollPosition) {
    this.scrollPosition = scrollPosition;
    if(this.isAnimationAplicable(scrollPosition)) {
      this.animate();
    }
  }

  isAnimationAplicable(scrollPosition){

    if(this.animationNode.classList.contains('animate')){
      return false;
    }
    let currentDeviceWidth = 
      window.innerWidth < SETTINGS.BREAKPOINTS.SM ? 'LG':
      (window.innerWidth >= SETTINGS.BREAKPOINTS.SM &&  window.innerWidth < SETTINGS.BREAKPOINTS.MD ? 'SM':
      (window.innerWidth >= SETTINGS.BREAKPOINTS.MD &&  window.innerWidth < SETTINGS.BREAKPOINTS.LG ? 'MD': 'LG'));
    let breakpoint = scrollPosition + (window.innerHeight - (window.innerHeight * SETTINGS.SCROLL_ANIMATION_BREAKPOINTS[currentDeviceWidth] / 100));
    return breakpoint > this.getOffsetTop(this.animationNode);
  }

  getOffsetTop(element){
    if(element.getAttribute('data-type') === 'svg-inner') {
      let svgNode = element.closest("svg");
      let svgOffsetTop = svgNode.getBoundingClientRect().top;
      let svgHeight = svgNode.getBoundingClientRect().height;
      let svgVBHeight = svgNode.viewBox.baseVal.height;
      let elVBOffsetY = element.getBBox().y;
      return svgOffsetTop + this.scrollPosition + (elVBOffsetY * svgHeight / svgVBHeight);
    }
    else {
      var offsetTop = 0;
      do {
        offsetTop += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);
      return offsetTop;
    }
  }


  animate(){
    this.animationNode.classList.add('animate');
    let ev = new Event('scrollanimation');
    this.animationNode.dispatchEvent(ev);
  }

}


// WEBPACK FOOTER //
// ./ui/assets/js/ScrollAnimation/ScrollAnimation.js